import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { BUSINESS, IMAGES } from "../data";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative py-24 md:py-32 scroll-mt-20 overflow-hidden"
  >
    <div aria-hidden className="absolute right-0 top-1/4 w-[28rem] h-[28rem] rounded-full bg-violet/10 blur-[120px]" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <Reveal>
          <p className="mb-5 inline-flex items-center gap-2 text-xs sm:text-sm tracking-[0.2em] uppercase font-bold text-neon">
            <span className="h-px w-8 bg-neon" /> 01 — About
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight leading-tight">
            A gaming destination
            <span className="block text-white/40">in the heart of Jakarta</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-base md:text-lg text-white/70 leading-relaxed">
            MEGAWIN5K is a game store in Pondok Indah Mall, Jakarta Selatan, where
            gaming and entertainment come together in one welcoming space. Whether
            you're dropping by for a quick session or settling in for a longer
            visit, it's a place designed around play.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">
            With{" "}
            <span className="text-neon font-semibold">
              {BUSINESS.reviews} Google reviews
            </span>
            , MEGAWIN5K has become a familiar name for gaming in Jakarta — open
            from {BUSINESS.opens} and ready to welcome visitors from across the
            city.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <motion.div
          whileHover={{ scale: 1.01 }}
          transition={{ duration: 0.4 }}
          className="relative rounded-3xl overflow-hidden border border-white/10 group"
        >
          <img
            src={IMAGES.interior}
            alt="Interior of MEGAWIN5K game store filled with games in Jakarta Selatan, Indonesia"
            className="w-full h-[26rem] lg:h-[32rem] object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-neon">
              MEGAWIN5K
            </p>
            <p className="mt-1 text-white/80 text-sm">{BUSINESS.addressFull}</p>
          </div>
        </motion.div>
      </Reveal>
    </div>
  </section>
);
